export const VOUCHER_CANCELLATION_PATHNAME = '/BookingApi/CancelBookingAndGenerateVoucher'

export function isVoucherCancellationUrlValid(voucherCancellationUrl: string | null | undefined): voucherCancellationUrl is string {
  if (typeof voucherCancellationUrl !== 'string')
    return false

  const normalizedUrl = voucherCancellationUrl.trim()
  if (!normalizedUrl || !normalizedUrl.startsWith('/'))
    return false

  try {
    const parsedUrl = new URL(normalizedUrl, 'https://example.invalid')
    return parsedUrl.pathname === VOUCHER_CANCELLATION_PATHNAME
      && parsedUrl.searchParams.has('bookingNumber')
  }
  catch {
    return false
  }
}
